import * as Yup from "yup";

export const FORGOT_PASSWORD_SCHEMA = Yup.object().shape({
  email: Yup.string()
    .email("Please enter valid email")
    .required("Admin Email is required.")
});
